import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import {
  Box as MuiBox,
  Fade as MuiFade,
  Popper as MuiPopper,
  Divider as MuiDivider,
  Typography as MuiTypography,
  useTheme,
} from '@mui/material';
import { ClickAwayListener as MuiClickAwayListener } from '@mui/base';
import {
  EditOutlined as EditIcon,
  DeleteForeverOutlined as DeleteIcon,
  ArchiveOutlined as ArchiveIcon,
  MoreVert as MoreVertIcon,
} from '@mui/icons-material';

const actions = (t, theme) => [
  {
    icon: <EditIcon style={{ color: theme.palette.colors.gray400, fontSize: 18 }} />,
    label: t('Edit'),
    isEdit: true,
  },
  {
    icon: <ArchiveIcon style={{ color: theme.palette.colors.gray400, fontSize: 18 }} />,
    label: t('Archive'),
    isArchive: true,
  },
];

const ActionPopper = ({ openAction, item }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const { t } = useTranslation();
  const theme = useTheme()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  const clear = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const onActionClick = useCallback(({ isEdit, isArchive }) => {
    clear();
    openAction({ isEdit, isArchive }, item);
  }, []);

  return (
    <SActionsWrapper>
      <MoreVertIcon
        aria-describedby={`open-popper-${item?.id_}`}
        data-id={`open-actions-${item?.id_}`}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      />

      <MuiPopper
        id={`open-popper-${item?.id_}`}
        open={open}
        anchorEl={anchorEl}
        placement="left"
        transition
      >
        {({ TransitionProps }) => (
          <MuiFade {...TransitionProps} timeout={300}>
            <div>
              <MuiClickAwayListener onClickAway={clear}>
                <SActionsList>
                  {actions(t, theme).map((action, idx) => (
                    <SActionItem
                      key={idx}
                      onClick={() => onActionClick(action)}
                    >
                      <MuiBox display="flex" alignItems="center">
                        {action.icon}
                        <SActionLabel>{action.label}</SActionLabel>
                      </MuiBox>
                      <MuiBox mt={1}>
                        <MuiDivider />
                      </MuiBox>
                    </SActionItem>
                  ))}
                </SActionsList>
              </MuiClickAwayListener>
            </div>
          </MuiFade>
        )}
      </MuiPopper>
    </SActionsWrapper>
  );
};

const SActionLabel = styled(MuiTypography)`
  font-size: 15px;
  margin-left: 10px;
  line-height: 18px;
  color: ${({theme}) => theme.palette.colors.gray400};
`;

const SActionsWrapper = styled(MuiBox)`
  position: absolute;
  right: 0;
  top: 10px;
`;

const SActionsList = styled(MuiBox)`
  background: ${({theme}) => theme.palette.colors.white};
  padding: 25px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
`;

const SActionItem = styled(MuiBox)`
  width: 100px;
  cursor: pointer;
  padding-top: 8px;
`;

export default ActionPopper;
